export default {
  heading: {
    widgetName: "Tiktok-Value-Packs",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Shop By Category",
    headlineType: "h2",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer in Penang`,
      eventLabelCardClick: `Grocer in Penang | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer in Penang | headline | {{headline}}`,
      eventLabelView: `Grocer in Penang`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/penang-veggie-and-fruits.jpg",
      title: "Farm Fresh Fruit & Veggies",
      subtitle: "",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Shop Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/tag/pg-pg-fruit-and-veggies?name=Penang%20Fresh%20Fruit%20and%20Veggies&tag_type=1"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/penang-fresh-meat.jpg",
      title: "All The Meat You Can Eat",
      subtitle: "",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Shop Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/tag/pg-pg-meat-and-poultry?name=Penang%20Fresh%20Meat%20and%20Poultry&tag_type=1"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/penang-coffee.jpg",
      title: "Best Coffee In Penang",
      subtitle: "",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Shop Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/tag/pg-pg-coffee?name=Famous%20Penang%20Coffee&tag_type=1"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/penang-groceries-and-pastes.jpg",
      title: "Must-have Pantry Staples",
      subtitle: "",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Shop Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/tag/pg-pg-pantry?name=Penang%20Groceries%20and%20Pastes&tag_type=1"
    }
  ],
}
